import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import * as Yup from 'yup';


import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useState } from 'react';
import { Formik } from 'formik';
import Typography from '@mui/material/Typography';
import { PostLimitData } from '../../../../Axios/LimitManagement';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';





const KioskWithdrawl = () => {
  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });



  const [openAlert, setOpenAlert] = useState(false)
  const [alertType, setAlertType] = useState('success')
  const [alertMessage, setAlertMessage] = useState(null)

  // const handleOptionChange = (event) => {
  //   setAge(event.target.value);
  // };

  const [requestType, setRequestType] = React.useState('');

  const handleTypeChange = (event) => {
    setRequestType(event.target.value);
  };



  const handlepostRequest = (data) => {
    PostLimitData(PostBankDetails, data, setOpenAlert, setAlertType, setAlertMessage)
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenAlert(false);
  };

  console.log(File);

  return (
    <div style={{ height: '70vh', paddingBottom: useMediaQuery('(max-width:600px)') ? '100px' : '0px', overflowY: 'scroll', scrollbarWidth: 'none' }}>
      <Formik
        initialValues={{
          originator_name: '',
          originator_bank: '',
          request_type: '',
          deposit_date: ''
        }}
        validationSchema={Yup.object().shape({

          ko_code: Yup.string().required('This field is required'),
          amount: Yup.string().required('Amount is required'),
          account_number: Yup.string().required('Amount is required'),
          ifsc: Yup.string().required('Amount is required'),

        })}
        onSubmit={(values, { setSubmitting }) => {
          try {

            handlepostRequest({ ...values, bank_recipt: File })
            setSubmitting(false);
          } catch (error) {
            console.log(error);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit} style={{ marginBlock: '50px' }}>
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert
                onClose={handleClose}
                severity={alertType}
                variant="filled"
                sx={{ width: '100%' }}
              >
                {alertMessage}
              </Alert>
            </Snackbar>
            <Grid container spacing={2}>


              <Grid item xl={4} md={4} sm={12} xs={12}>
                <TextField
                  type="text"
                  fullWidth
                  name="ko_code"
                  label="Originator Name"
                  error={errors.ko_code && touched.ko_code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.ko_code}
                />
                <Typography sx={{ color: 'red' }} variant='subtitle'>
                  {errors.ko_code && touched.ko_code && errors.ko_code}
                </Typography>
              </Grid>



              <Grid item xl={4} md={12} sm={12} xs={12}>
                <TextField
                  type="text"
                  fullWidth
                  name="amount"
                  label="Originator Bank"
                  error={errors.amount && touched.amount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.amount}
                />
                <Typography sx={{ color: 'red' }} variant='subtitle'>
                  {errors.amount && touched.amount && errors.amount}
                </Typography>
              </Grid>

              <Grid item xl={4} md={12} sm={12} xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Request Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={requestType}
                    label="Request Type"
                    onChange={handleTypeChange  }
                  >
                    <MenuItem value={10}>Ten</MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                  </Select>
                </FormControl>
                <Typography sx={{ color: 'red' }} variant='subtitle'>
                  {errors.account_number && touched.account_number && errors.account_number}
                </Typography>
              </Grid>

              <Grid item xl={4} md={12} sm={12} xs={12}>
                <TextField
                  type="date"
                  fullWidth
                  name="ifsc"
                  label="Deposit Date/
                  Transfer(DD/MM/YYYY)"
                  focused={true}

                  error={errors.ifsc && touched.ifsc}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.ifsc}
                />
                <Typography sx={{ color: 'red' }} variant='subtitle'>
                  {errors.ifsc && touched.ifsc && errors.ifsc}
                </Typography>
              </Grid>

              <Grid item xl={4} md={12} sm={12} xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Bene Name</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={requestType}
                    label="Request Type"
                    onChange={handleTypeChange  }
                  >
                    <MenuItem value={10}>Ten</MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                  </Select>
                </FormControl>
                <Typography sx={{ color: 'red' }} variant='subtitle'>
                  {errors.account_number && touched.account_number && errors.account_number}
                </Typography>
              </Grid>

              <Grid item xl={4} md={12} sm={12} xs={12}>
                <TextField
                  type="text"
                  fullWidth
                  name="amount"
                  label="Amount"
                  error={errors.amount && touched.amount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.amount}
                />
                <Typography sx={{ color: 'red' }} variant='subtitle'>
                  {errors.amount && touched.amount && errors.amount}
                </Typography>
              </Grid>

              <Grid item xl={4} md={12} sm={12} xs={12}>
                <TextField
                  type="text"
                  fullWidth
                  name="amount"
                  label="Bene A/C No"
                  error={errors.amount && touched.amount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.amount}
                />
                <Typography sx={{ color: 'red' }} variant='subtitle'>
                  {errors.amount && touched.amount && errors.amount}
                </Typography>
              </Grid>

              <Grid item xl={4} md={12} sm={12} xs={12}>
                <TextField
                  type="text"
                  fullWidth
                  name="amount"
                  label="Branch Code"
                  error={errors.amount && touched.amount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.amount}
                />
                <Typography sx={{ color: 'red' }} variant='subtitle'>
                  {errors.amount && touched.amount && errors.amount}
                </Typography>
              </Grid>

              <Grid item xl={4} md={12} sm={12} xs={12}>
                <TextField
                  type="text"
                  fullWidth
                  name="amount"
                  label="Reference No"
                  error={errors.amount && touched.amount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.amount}
                />
                <Typography sx={{ color: 'red' }} variant='subtitle'>
                  {errors.amount && touched.amount && errors.amount}
                </Typography>
              </Grid>

              <Grid item xl={4} md={6} sm={12} xs={12}>
                        <TextField
                          type="text"
                          fullWidth
                          disabled
                          name="bank_recipt"
                          label="Bank Recipt"
                          error={errors.bank_recipt && touched.bank_recipt}
                          onBlur={handleBlur}
                          value={values.bank_recipt}
                          InputProps={{
                            endAdornment: (
                              <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                                color='secondary'
                              >
                                Upload
                                <VisuallyHiddenInput onChange={(e) => handleFileUpload(e.target.files[0], setFieldValue)} type="file" />
                              </Button>
                            ),
                          }}
                        />
                        <Typography sx={{ color: 'red' }} variant='subtitle'>
                          {errors.bank_recipt && touched.bank_recipt && errors.bank_recipt}
                        </Typography>
                      </Grid>

              <Grid display='flex' item xl={12} lg={12} md={12} sm={12} xs={12} justifyContent='flex-end'>
                <Button type="submit" variant='contained' size='small' color='secondary' disabled={isSubmitting}>
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </div>
  )

};

export default KioskWithdrawl;


